import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useEffect, useState } from 'react';
import AppStoreLogo from './Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import api from './api';

const Landing: FunctionComponent<{}> = () => {
    const [appStoreLink, setAppStoreLink] = useState('');

    useEffect(() => {
        api.getLandingAll().then(landing => {
            setAppStoreLink(landing.appStoreLink);
        });
    }, []);

    return (
        <>
            {/* Old code commented out
            <h1>The Online Yard Sale community</h1>
            ...
            */}

            <div className="text-center my-5">
                <h1>Discover the value in what you own!</h1>
                <h5 className="mt-3">
                    Explore unique items from various sellers in your neighborhood
                </h5>
            </div>

            {/* Role Cards */}
            <div className="container my-5">
                <div className="row text-center">
                    <div className="col-md-4 mb-4">
                        <div className="p-5 border rounded shadow-sm landing-card" style={{ minHeight: '250px' }}>
                            <h4 className="mb-4">As a seller</h4>
                            <img src="/pricetag.png" alt="As a seller" style={{ height: '140px' }} />
                            <p className="mt-3">Earn money by selling your preloved items. Turn clutter into cash.</p>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="p-5 border rounded shadow-sm landing-card" style={{ minHeight: '250px' }}>
                            <h4 className="mb-4">As a buyer</h4>
                            <img src="/cart.png" alt="As a buyer" style={{ height: '140px' }} />
                            <p className="mt-3">Discover unique finds and great deals from our diverse community.</p>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="p-5 border rounded shadow-sm landing-card" style={{ minHeight: '250px' }}>
                            <h4 className="mb-4">As a trader</h4>
                            <img src="/value.png" alt="As a trader" style={{ height: '140px' }} />
                            <p className="mt-3">Connect with sellers and buyers to trade items you love.</p>
                        </div>
                    </div>
                </div>
            </div>


            {/* How it works */}
            <div className="container mb-5">
                <div className="row border-top">
                    {/* Step 1 */}
                    <div className="col-md-4 py-4 text-center border-end position-relative step-card">
                        <div className="step-badge">1</div>
                        <img src="/products.png" alt="Post a Listing" style={{ height: '80px', marginTop: '10px' }} />
                        <h5 className="mt-3">Post a Listing</h5>
                        <p>Create a listing for your item. Describe your item. Add photos, details, and set a price.</p>
                    </div>

                    {/* Step 2 */}
                    <div className="col-md-4 py-4 text-center border-end position-relative step-card">
                        <div className="step-badge">2</div>
                        <img src="/handshake.png" alt="Negotiate" style={{ height: '80px', marginTop: '10px' }} />
                        <h5 className="mt-3">Negotiate the price</h5>
                        <p>Discuss and finalize the deal with the seller. Find the best value for your item.</p>
                    </div>

                    {/* Step 3 */}
                    <div className="col-md-4 py-4 text-center position-relative step-card">
                        <div className="step-badge">3</div>
                        <img src="/negotiate.png" alt="We handle the rest" style={{ height: '80px', marginTop: '10px' }} />
                        <h5 className="mt-3">We handle the rest</h5>
                        <p>Sit back and relax. We'll take care of shipping and payments!</p>
                    </div>
                </div>
            </div>

            {/* App Store Button */}
            <div className="text-center my-5">
                <a href={appStoreLink}>
                    <img src={AppStoreLogo} alt="Download on the App Store" style={{ height: '60px' }} />
                </a>
            </div>

            {/* Email signup */}
            <div className="text-center mb-5">
                <p className="mb-2">Join our community for exclusive deals and updates!</p>
                <form className="d-inline-flex justify-content-center align-items-center flex-wrap gap-2" style={{ maxWidth: '100%' }}>
                    <input
                        type="email"
                        placeholder="Email"
                        className="form-control"
                        style={{ width: '250px', minWidth: '180px' }}
                    />
                    <button type="submit" className="btn btn-dark white-nowrap">Join now</button>
                </form>
            </div>


        </>
    );
};

export default Landing;
